import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import VerifyEmail from "@/pages/VerifyEmail";
import Auth from "@/pages/Auth";
import Discover from "@/pages/Discover";
import Matches from "@/pages/Matches";
import Chat from "@/pages/Chat";
import Events from "@/pages/Events";
import ProfileEdit from "@/pages/ProfileEdit";
import VideoCall from "@/pages/VideoCall";
import Creators from "@/pages/Creators";
import CreatorProfile from "@/pages/CreatorProfile";
import Requests from "@/pages/Requests";
import Subscribers from "@/pages/Subscribers";
import LikesYou from "@/pages/LikesYou";
import Legal from "@/pages/Legal";
import Charter from "@/pages/Charter";
import EventRoom from "@/pages/EventRoom";
import Lounge from "@/pages/Lounge";
import Verify from "@/pages/Verify";
import AdminVerifications from "@/pages/AdminVerifications";
import Referrals from "@/pages/Referrals";
import Analytics from "@/pages/Analytics";
import Quiz from "@/pages/Quiz";
import Help from "@/pages/Help";
import Payouts from "@/pages/Payouts";
import Avatar from "@/pages/Avatar";
import MapPage from "@/pages/MapPage";
import AdminCommand from "@/pages/AdminCommand";
import Wallet from "@/pages/Wallet";
import Leaderboard from "@/pages/Leaderboard";
import CreatorOnboarding from "@/pages/CreatorOnboarding";
import FoundingCreators from "@/pages/FoundingCreators";
import Feedback from "@/pages/Feedback";
import BlockedList from "@/pages/BlockedList";
import Layout from "@/components/Layout";
import AgeGate from "@/components/AgeGate";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-[#D4AF37] font-heading text-2xl">Loading Empire…</div>;
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}

function Shell({ children }) {
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App grain">
      <AuthProvider>
        <BrowserRouter>
          <Toaster theme="dark" position="top-center" richColors />
          <AgeGate />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/charter" element={<Charter />} />
            <Route path="/founding-creators" element={<FoundingCreators />} />
            <Route path="/discover" element={<Protected><Shell><Discover /></Shell></Protected>} />
            <Route path="/matches" element={<Protected><Shell><Matches /></Shell></Protected>} />
            <Route path="/chat/:matchId" element={<Protected><Shell><Chat /></Shell></Protected>} />
            <Route path="/events" element={<Protected><Shell><Events /></Shell></Protected>} />
            <Route path="/creators" element={<Protected><Shell><Creators /></Shell></Protected>} />
            <Route path="/creator/:id" element={<Protected><Shell><CreatorProfile /></Shell></Protected>} />
            <Route path="/requests" element={<Protected><Shell><Requests /></Shell></Protected>} />
            <Route path="/subscribers" element={<Protected><Shell><Subscribers /></Shell></Protected>} />
            <Route path="/likes" element={<Protected><Shell><LikesYou /></Shell></Protected>} />
            <Route path="/profile" element={<Protected><Shell><ProfileEdit /></Shell></Protected>} />
            <Route path="/blocked" element={<Protected><Shell><BlockedList /></Shell></Protected>} />
            <Route path="/verify" element={<Protected><Shell><Verify /></Shell></Protected>} />
            <Route path="/referrals" element={<Protected><Shell><Referrals /></Shell></Protected>} />
            <Route path="/wallet" element={<Protected><Shell><Wallet /></Shell></Protected>} />
            <Route path="/leaderboard" element={<Protected><Shell><Leaderboard /></Shell></Protected>} />
            <Route path="/analytics" element={<Protected><Shell><Analytics /></Shell></Protected>} />
            <Route path="/quiz" element={<Protected><Shell><Quiz /></Shell></Protected>} />
            <Route path="/help" element={<Protected><Shell><Help /></Shell></Protected>} />
            <Route path="/payouts" element={<Protected><Shell><Payouts /></Shell></Protected>} />
            <Route path="/creator-onboarding" element={<Protected><Shell><CreatorOnboarding /></Shell></Protected>} />
            <Route path="/feedback" element={<Protected><Shell><Feedback /></Shell></Protected>} />
            <Route path="/avatar" element={<Protected><Shell><Avatar /></Shell></Protected>} />
            <Route path="/map" element={<Protected><Shell><MapPage /></Shell></Protected>} />
            <Route path="/admin/command" element={<Protected><Shell><AdminCommand /></Shell></Protected>} />
            <Route path="/admin/verifications" element={<Protected><Shell><AdminVerifications /></Shell></Protected>} />
            <Route path="/call/:roomId" element={<Protected><VideoCall /></Protected>} />
            <Route path="/event/:eventId/live" element={<Protected><EventRoom /></Protected>} />
            <Route path="/lounge/:type" element={<Protected><Lounge /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
